@if (loader) {
  <div class="loader">
    <div class="imgloader">
      <div class="round">
        <div class="custom-loader"></div>
      </div>
      <!-- <img src="assets/images/nsf_loader.gif" alt="loader" /> -->
    </div>
  </div>
}
